export default __webpack_public_path__ + "static/sophie-4490fed539ec4004939cc619a373dd71.svg";